
import { Options, Vue } from 'vue-class-component';
import { mapGetters } from 'vuex';
import Logo from '@/base-components/Logo.vue';

@Options({
  components: { Logo },
  computed: {
    ...mapGetters(['getJsonData']),
    jsonData() {
      const jsonData = (this as any).getJsonData;
      const jsonDataWithBreaks = JSON.stringify(jsonData).replace(/\\n/g, '<br>');
      return JSON.parse(jsonDataWithBreaks);
    }
  }
})
export default class TermsView extends Vue {}
